export default __webpack_public_path__ + "static/media/icon_privacy_home_safety_icon-1.da28834f.svg";